import React, { useState } from 'react';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useAuth } from '../contexts/AuthContext';

function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [authError, setAuthError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setAuthError('');
    setIsLoading(true);
    
    try {
      const result = await login(username, password);
      
      if (!result.success) {
        setAuthError(result.error || 'Forkert brugernavn eller password');
      }
      // On success, AuthContext will update and user will be logged in
    } catch (error) {
      setAuthError('Der opstod en fejl. Prøv igen.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="login-brand">
          <span className="login-brand-icon" aria-hidden="true"><ConstructionIcon /></span>
          <div>
            <h1>Tilbudgivern</h1>
            <p>Professionelle tilbud. Ét samlet arbejdsflow.</p>
          </div>
        </div>
        <h2>Log ind</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Brugernavn</label>
            <input
              type="text"
              id="username"
              name="username"
              placeholder="Indtast brugernavn"
              aria-label="Brugernavn"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Indtast password"
              aria-label="Password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              required
            />
          </div>
          {authError && <div className="error">{authError}</div>}
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? 'Logger ind...' : 'Log ind'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
